import { GlobalAppState } from '@state/store';

export const getPath = (state: GlobalAppState) => state.app.path;
